import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { ShouldDisplayMessageCTADataFn } from "../../instantAnswerDataFunctions/shouldDisplayMessageCTADataFn";

import { UpdateTaxInformationCTA } from "./ctas";

export const TaxInformationIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.();
      },
    },

    additionalRequiredData: [
      ShippingContextDataFn,
      ShouldDisplayMessageCTADataFn,
    ],
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UPDATE_TAX_INFORMATION_TITLE(strictLocalize),
    getDescription: () => [
      UPDATE_TAX_INFORMATION_LIST1(strictLocalize),
      UPDATE_TAX_INFORMATION_LIST2(strictLocalize),
      UPDATE_TAX_INFORMATION_LIST3(strictLocalize),
    ],
  };
};

const UPDATE_TAX_INFORMATION_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "How to update your tax information",
    description: {
      text: "Title for the answer of updating tax information",
    },
  });

const UPDATE_TAX_INFORMATION_LIST1 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "1. Go to your Account settings.",
  });
const UPDATE_TAX_INFORMATION_LIST2 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "2. Navigate to the Import & tax information section within My profile to change details like your 1099-k, VAT.",
  });
const UPDATE_TAX_INFORMATION_LIST3 = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "3. Save any changes you make.",
  });

const getPrimaryCTA: CtaBuilderFn = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => UpdateTaxInformationCTA(strictLocalize);
